import { groq } from 'next-sanity'

export const getAllCitiesInCountryByTypeQuery = (
  locale: AppLocale,
  countryId: string,
  offset?: number,
) => groq`
  *[_type == "city" && defined(slug.${locale}.current) && country._ref == "${countryId}"]
  | order(number_activities.${locale} desc)
  {
   ${getReducedCityFields(locale)}
  }
  ${offset === -1 ? '' : `[${offset || 0}...${(offset || 0) + 50}]`}
`

export const getAllCitiesInStateQuery = (
  locale: AppLocale,
  stateId: string,
  offset?: number,
) => groq`
  *[_type == "city" && defined(slug.${locale}.current) && state._ref == "${stateId}"]
  | order(number_activities.${locale} desc)
  {
   ${getReducedCityFields(locale)}
  }
  ${offset === -1 ? '' : `[${offset || 0}...${(offset || 0) + 50}]`}
`

export const getAllCitiesInRegionQuery = (
  locale: AppLocale,
  regionId: string,
  offset?: number,
) => groq`
  *[_type == "city" && defined(slug.${locale}.current) && "${regionId}" in region[]._ref] 
  | order(number_activities.${locale} desc) 
  {
    ${getReducedCityFields(locale)}
  } 
  ${offset === -1 ? '' : `[${offset || 0}...${(offset || 0) + 50}]`}
`

export const getAllCitiesQuery = (locale: AppLocale, offset?: number) => groq`
  *[_type == "city" && defined(slug.${locale}.current)]
  | order(number_activities.${locale} desc)
  {
   ${getReducedCityFields(locale)}
  }
  ${offset === -1 ? '' : `[${offset || 0}...${(offset || 0) + 50}]`}
`

export const getAllCitiesInCountryQuery = (
  locale: AppLocale,
  countryId: string,
  offset?: number,
) => groq`
  *[_type == "city" && defined(slug.${locale}.current) && country._ref == "${countryId}"]
  | order(number_activities.${locale} desc)
  {
    ${getReducedCityFields(locale)}
  }
  ${offset === -1 ? '' : `[${offset || 0}...${(offset || 0) + 50}]`}
`

const getReducedCityFields = (locale: AppLocale) => ` 
  _id,
  _type,
  _updatedAt,
  "name": name.${locale},
  "h1": h1.${locale},
  slug,
  coverImage,
  priority,
  reviews,
  "number_activities": number_activities.${locale},
  number_locations,
`

export const getCityBySlugQuery = (locale: AppLocale, citySlug: string) => groq`
  *[_type == "city" && slug.${locale}.current == "${citySlug}"][0] {
    _id,
    _type,
    product_link,
    "name": name.${locale},
    "nameDescription": name_description.${locale},
    "h1": h1.${locale},
    slug,
    coverImage,
    "highlights": highlights.${locale},
    "description_1": description_1.${locale},
    "description_2": description_2.${locale},
    "description_3": description_3.${locale},
    "faq": faq.${locale},
    reviews,
    "travelPlanWidget": travel_plan_widget-> {
      _type,
      global_link,
      "sub_title": sub_title.${locale},
      "title": title.${locale},
      "text_above": text_above.${locale},
      image
    },
    "meta_title": meta_title.${locale},
    "meta_description": meta_description.${locale},
    "country": country->{
      _id,
      "name": name.${locale},
      slug
    },
    "state": state->{
      _id,
      "name": name.${locale},
      "slug": slug.${locale}.current
    },
    "number_activities": number_activities.${locale},
    number_locations,
    "dynamicFooter": dynamic_footer.${locale}
  }
`
